<template>
  <Header :show="showHeader"></Header>
  <Fixed :show="showRouter" :showDot="showDot" />
  <router-view />
  <Footer :show="showFooter"></Footer>
</template>
<script setup>
import { ref, provide, nextTick } from 'vue'
import { mapState } from 'vuex';
const isRouterActive = ref(true)
let showDot=ref(true)
provide('reload', () => {
  isRouterActive.value = false
  nextTick(() => {
    isRouterActive.value = true
  })
})
</script>
<script>
export default {
  computed: {
    ...mapState(['showHeader', 'showFooter', 'showRouter']), // 映射 Vuex 状态
  },
  data() {
    return {
        config:{
          app: {
            cdnurl: '',
            avatar: '',
            privacy_agreement: '',
            user_agreement: '',
            activity_agreement: '',
            invoice_agreement: '',
            auto_close: 0,
            activity_newsample_agreement: '',
            activity_seckill_agreement: '',
            activity_groupon_agreement: '',
            activity_expire_food_agreement: '',
            legal_authorization_example: '',
            tel: '',
            customer_qrcode: '',
            wxmini_code: '',
            wxoffical_code: ''
          }
        }
    };
  },
  mounted() {
    this.$bus.on('refreshPage', () => {
      window.location.reload();
    })
    var app = this;
    setTimeout(function() {
				// app初始化完成后再执行
				app.$api.ConfigInit().then(ret=>{
          app.config = ret.data;
          app.$bus.emit("initSuccess",{});
        })
		}, 1);
  },
  beforeUnmount() {
    this.$bus.off('refreshPage');
  },
  methods: {

  },
}
</script>
<style lang="less">
@import url(./assets/css/reset.css);
@import url(./assets/css/style.css);
</style>
